module.exports = __webpack_public_path__ + "static/img/ipod.424d0dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/imgs/ipod.jpg
// module id = JTM1
// module chunks = 0